import { axiosClient } from "services/axios";

import { AddArticleParams, EditArticleParams } from "../types";

export function addArticle(params: AddArticleParams) {
  return axiosClient.post("article/create", params);
}

export function editArticle(params: EditArticleParams) {
  return axiosClient.put("article/update", params);
}
